module.exports = __webpack_public_path__ + "static/media/astro.feed7d6a.png";